// removed by extract-text-webpack-plugin
module.exports = {"numericPage":"numericPage__Q0SHD"};


//////////////////
// WEBPACK FOOTER
// ./components/numeric/style.css
// module id = Y0wl
// module chunks = 0